import { useTranslation } from 'react-i18next';

export const useNotesInfoText = (): string => {
  const { t } = useTranslation('notes');
  return t(
    'notes_info_message',
    'Notes are for use either internally (with own consultee colleagues) or externally (with planning authority case officers) for informal clarification or updates only. Any material information requests should be dealt with through the normal consultation process.'
  );
};
